// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"5a948513","284":"a40fbdd5","296":"15e867ed"}[chunkId] + ".chunk.js";
};